import { Injectable } from "@angular/core";
import { RestService } from "@stdoutsrl/design-kit";
import { api } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class BookingService {
  constructor(private rest: RestService) {}

  addPrenotation(event: any) {
    return this.rest.post(`/booking/salon`, event);
  }

  getMySalonsLimit() {}

  searchOneClient(lastName: string, phone: string) {
    return this.rest.get(`/user/search?lastName=${lastName}&phone=${phone}`);
  }

  getUsersPrenotation() {
    return this.rest.get(`/user/customers`);
  }

  editPrenotation(event: any) {
    return this.rest.put(`/booking/salon`, event);
  }

  deleteBooking(event: any) {
    return this.rest.delete(`/booking/salon/${event.id}`);
  }

  getCalendarPrenotations(start: string, end: string, salon: string) {
    return this.rest.get(
      `/booking/salon?start=${start}&end=${end}&salon=${salon}`
    );
  }

  getCalendarShifts(start: string, end: string, operator: string) {
    return this.rest.get(
      `/operator/shifts/${operator}?start=${start}&end=${end}`
    );
  }

  addCalendarShift(body: any) {
    return this.rest.post(`/operator/shifts`, body);
  }

  editCalendarShift(body: any) {
    return this.rest.patch(`/operator/shifts`, body);
  }

  getMySalons() {
    return this.rest.get(api.endpoint.mySalons);
  }

  getMyOperators(id: number) {
    return this.rest.get(`/company/${id}/operator`);
  }

  getSuggestedSlots(
    id: number,
    start: string,
    end: string,
    itemId: number,
    operatorId: number
  ) {
    return this.rest.get(
      `/booking/available/by_operators/${id}/${operatorId}?start=${start}&end=${end}&itemId=${itemId}`
    );
  }

  getMyProducts(id: number) {
    return this.rest.get(`/company/${id}/item`);
  }

  getMyCompany() {
    return this.rest.get(api.endpoint.myCompany);
  }
}
